import script from "./ChangeGroupForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ChangeGroupForm.vue?vue&type=script&setup=true&lang=js"

import "./ChangeGroupForm.vue?vue&type=style&index=0&id=ea668f28&scoped=true&lang=postcss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ea668f28"]])

export default __exports__